import React, { PureComponent } from 'react';
import { HELPER, JsBridge } from 'utils';

import moment from 'moment';
import get from 'lodash/get';

import danaLogo from 'assets/images/invoice/dana_logo.svg';
import danaProtect from 'assets/images/invoice/dana_protection.svg';
import iconHelp from 'assets/images/invoice/help.svg';

import created from 'assets/images/invoice/created.svg';
import processing from 'assets/images/invoice/processing.svg';
import waiting from 'assets/images/invoice/waiting.svg';
import success from 'assets/images/invoice/success.svg';
import failed from 'assets/images/invoice/failed.svg';
import refund from 'assets/images/invoice/refund.svg';
import pending from 'assets/images/invoice/pending.svg';

import text from './InvoicePage.page.translation';
import config from './InvoicePage.page.config';

import './InvoicePage.less';
export class InvoicePage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      invoceHeight: 0,
      invoiceExpand: false,
    };
  }

  _callbackInvoice = (id, retry) => () => {
    this.props.setLoading(false);
    this.props.setErrorState(false);
    if (retry) setTimeout(this._recursiveCall(id), 5000);
  };

  _setTitle = () => {
    JsBridge.setTitle(`${this.props.intl.formatMessage(text.header)}`);
  };

  componentDidMount() {
    const id = HELPER.getParamURL('order_number');
    const { setLoading, getInvoice } = this.props;
    document.addEventListener('AlipayJSBridgeReady', this._setTitle, false);
    setLoading(true);
    getInvoice(id)
      .then(this._callbackInvoice(id, false))
      .catch(this._callbackInvoice(id, true));
  }

  _recursiveCall = id => () => {
    this.props.getInvoice(id).catch(this._callbackInvoice(id, true));
  };

  _expandInvoice = () => {
    if (!this.state.invoiceExpand) this.setState({ invoiceExpand: true });
  };

  _renderDetail = () => {
    const {
      invoiceData,
      intl: { formatMessage },
    } = this.props;

    const invoiceNumber = get(invoiceData, 'invoice_number', '');

    return (
      <div className="separator">
        <span className="detail">{formatMessage(text.title)}</span>
        <div className="row item">
          <span>{formatMessage(text.service)}</span>
          <span className="value">
            {get(invoiceData, 'biller.service.name', '')}
          </span>
        </div>
        <div className="row item">
          <span>{formatMessage(text.biller)}</span>
          <span className="value">{get(invoiceData, 'biller.name', '')}</span>
        </div>
        <div className="row item">
          <span>{formatMessage(text.cust_no)}</span>
          <span className="value">
            {get(invoiceData, 'beneficiary_account_number', '').replace(
              '****',
              '••••',
            )}
          </span>
        </div>
        <div className="row item">
          <span>{formatMessage(text.cust_name)}</span>
          <span className="value">
            {get(invoiceData, 'beneficiary_full_name', '')}
          </span>
        </div>
        <div className="row item">
          <span>{formatMessage(text.number)}</span>
          <span className="value">
            <div onClick={this._expandInvoice}>
              {this.state.invoiceExpand
                ? invoiceNumber
                : `••••${invoiceNumber.substr(-4)}`}
            </div>
          </span>
        </div>
      </div>
    );
  };

  _renderProgress = () => {
    const {
      invoiceData,
      intl: { formatMessage },
    } = this.props;
    const status = get(invoiceData, 'sales_order.order_status', 'IN_PROGRESS');

    const resultStatus = [
      {
        key: 0,
        img: created,
        word: formatMessage(text.created),
      },
      {
        key: 1,
        img: processing,
        word: formatMessage(text.process),
      },
    ];

    switch (status) {
      case 'COMPLETED':
        resultStatus.push({
          key: 2,
          img: success,
          word: formatMessage(text.success),
        });
        break;
      case 'FAILED':
        resultStatus.push({
          key: 2,
          img: failed,
          word: formatMessage(text.failed),
        });
        break;
      case 'REFUNDED':
        resultStatus.push({
          key: 2,
          img: refund,
          word: formatMessage(text.refunded),
        });
        break;
      case 'IN_PROGRESS':
      default:
        resultStatus.push({
          key: 2,
          img: waiting,
          word: formatMessage(text.progress),
        });
        break;
    }

    return resultStatus.map((step, index) => {
      if (index > 0) {
        return (
          <div key={`step_${step.key}`} className="not-first">
            <div className="line" />
            <div className="step">
              <img src={step.img} alt="" />
              <span>{step.word}</span>
            </div>
          </div>
        );
      }
      return (
        <div className="step first" key={`step_${resultStatus[0].key}`}>
          <img src={resultStatus[0].img} alt="" />
          <span>{resultStatus[0].word}</span>
        </div>
      );
    });
  };

  _renderExtLink = () => (
    <div
      className="row bottom"
      style={{
        top: this.state.invoceHeight,
      }}
    >
      <a href="https://m.dana.id/m/standalone/protection">
        <img src={danaProtect} alt="" className="protect" />
      </a>

      <a href="https://m.dana.id/m/standalone/help-center">
        <div>
          <span className="help">
            {this.props.intl.formatMessage(text.help)}
          </span>
          <img src={iconHelp} alt="" />
        </div>
      </a>
    </div>
  );

  _renderContent = () => {
    const {
      invoiceData,
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="content">
        <div className="top-content">
          <div className="row title">
            <span>
              {`${moment(get(invoiceData, 'dana_finish_time')).format(
                'DD MMM YYYY • HH:mm',
              )}`}
            </span>
            <span className="boxed">
              {get(invoiceData, 'biller.service.name', '').toUpperCase()}
            </span>
          </div>
        </div>
        <div className="progress">{this._renderProgress()}</div>
        <div className="row total">
          <span>{formatMessage(text.total)}</span>
          <span>
            {HELPER.formatRupiah(get(invoiceData, 'total_amount', 0))}
          </span>
        </div>
        <div className="row item">
          <span>{formatMessage(text.price)}</span>
          <span className="value">
            {HELPER.formatRupiah(get(invoiceData, 'transaction_amount', 0))}
          </span>
        </div>
        <div className="row item">
          <span>{formatMessage(text.admin)}</span>
          <span className="value">
            {HELPER.formatRupiah(get(invoiceData, 'admin_fee', 0))}
          </span>
        </div>
        {this._renderDetail()}
      </div>
    );
  };

  _renderPlaceholder = () => (
    <div className="content placeholder">
      <img src={pending} alt="" />
      <span>{this.props.intl.formatMessage(text.placeholder)}</span>
    </div>
  );

  _refOnPage = el => {
    if (!el) return;

    this.setState({
      invoceHeight: el.getBoundingClientRect().height,
    });
  };

  render() {
    const { invoiceData } = this.props;

    return (
      <div id="invoicePage">
        <div className="header" />
        <img src={danaLogo} alt="dana-logo" className="logo" />
        <div className="page" ref={this._refOnPage}>
          <div className="page-wrapper">
            {get(invoiceData, 'invoice_number')
              ? this._renderContent()
              : this._renderPlaceholder()}
            <div className="watermark" />
          </div>
        </div>

        {this._renderExtLink()}
      </div>
    );
  }
}

InvoicePage.propTypes = config.propTypes;
InvoicePage.displayName = config.displayName;
InvoicePage.defaultProps = config.defaultProps;

export default InvoicePage;
